import React from 'react'
import useAuth from '../../../../hooks/useAuth'
import {LoginCard} from './LoginCard'
import {AuthFullScreen} from './AuthFullScreen'

export function Login() {
  const {actionLoading, login} = useAuth()

  const handleSubmit = async (values: {username: string; password: string}) => {
    try {
      const res: any = await login(values)
      const payload = res?.payload
      if (payload?.success) {
        return null
      }
      return payload?.message || 'Identifiants incorrects.'
    } catch (err: any) {
      return err?.message || 'Erreur lors de la connexion.'
    }
  }

  return (
    <AuthFullScreen>
      <LoginCard onSubmit={handleSubmit} loading={actionLoading} />
    </AuthFullScreen>
  )
}
